<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-pencil
      </v-icon> Create Digi-Board
    </h2>
    <v-card
      class="my-base-vcard-style"
    >
      <br>
      <v-card
        class="my-vcard-style"
      >
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="digiBoardLocation"
                  label="Digi-Board Location*"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="digiBoardNumber"
                  label="Board Number"
                  hint="Name for your reference - 'BOARD_DBSYS_001'."
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="selectedOrganizationId"
                  menu-props="auto"
                  :items="organizationList"
                  hint="By choosing an organization, It's Id will get fetched."
                  :rules="[(v) => !!v || 'Organization Id is required']"
                  item-value="external_id"
                  prepend-icon="mdi-domain"
                  item-text="name"
                  label="Select Organization*"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="timeZone"
                  menu-props="auto"
                  :items="timeZonesByName"
                  label="Select Time Zone*"
                  prepend-icon="mdi-clipboard-text-clock-outline"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="start date"
                >
                  <v-datetime-picker
                    v-model="start"
                    label="Licensing From"
                    date-format="yyyy-MM-dd"
                    time-format="HH:mm:ss"
                    :text-field-props="{
                      suffix: userTimeZone,
                      errorMessages: errors,
                      class: 'custom-label-color',
                    }"
                    :date-picker-props="{
                      headerColor: '#37474F',
                      min: minStartDate
                    }"
                    :time-picker-props="{
                      headerColor: '#37474F'
                    }"
                  >
                    <template #dateIcon>
                      <v-icon
                        large
                        color="#37474F"
                      >
                        mdi-calendar
                      </v-icon>
                    </template>
                    <template #timeIcon>
                      <v-icon
                        large
                        color="#37474F"
                      >
                        mdi-alarm
                      </v-icon>
                    </template>
                  </v-datetime-picker>
                </validation-provider>
              </v-col>
              <v-col>
                <v-datetime-picker
                  v-model="end"
                  label="Licensing To"
                  :text-field-props="{
                    persistentHint: true,
                    suffix: userTimeZone,
                  }"
                  :date-picker-props="{
                    headerColor: '#37474F',
                    min: minEndDate
                  }"
                  :time-picker-props="{
                    headerColor: '#37474F'
                  }"
                >
                  <template #dateIcon>
                    <v-icon
                      large
                      color="#37474F"
                    >
                      mdi-calendar
                    </v-icon>
                  </template>
                  <template #timeIcon>
                    <v-icon
                      large
                      color="#37474F"
                    >
                      mdi-alarm
                    </v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="4"
              >
                <v-select
                  v-model="type"
                  menu-props="auto"
                  :items="typeItems"
                  label="Type*"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
            </v-row>
          </v-form>
          <br>
          <p class="text-sm-left">
            *Indicates required field
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="$router.push({ name: 'DigiBoards' })"
          >
            Back
          </v-btn>
          <v-spacer />
          <v-btn
            class="mt-2"
            color="#FF3700"
            @click="submit()"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import moment from 'moment-timezone';
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'CreateDigiBoards',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        digiBoardLocation: '',
        digiBoardNumber: null,
        timeZone: '',
        timeZones: ['Australia/Melbourne', 'Australia/Sydney'],
        type: '',
        typeItems: ['trial', 'free', 'monthly', 'yearly'],
        selectedOrganizationId: '',
        start: null,
        end: null,
        minStartDate: moment().format('YYYY-MM-DD'),
        valid: false,
        loading: false,
      };
    },
    computed: {
      organizationList () {
        return this.$store.getters['organizations/getOrganizationList'];
      },
      minEndDate () {
        return moment(this.start).format('YYYY-MM-DD');
      },
      createdDigiBoard () {
        return this.$store.getters['digiboards/getCreatedDigiBoard'];
      },
      allTimeZones () {
        return this.$store.getters['users/getTimeZones'];
      },
      timeZonesByName () {
        return Object.keys(this.allTimeZones).map((key) => ({ text: key, value: this.allTimeZones[key] }));
      },
      userTimeZone () {
        var Zone = moment.tz.guess();
        var timezone = moment.tz(Zone).zoneAbbr();
        return timezone;
      },
    },
    mounted () {
      this.$store.dispatch('organizations/fetchOrganizationList');
      this.getAllTimeZone();
    },
    methods: {
      convertToGmt (date) {
        return moment(date).utc();
      },
      async submit () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        await this.$store.dispatch('digiboards/createDigiBoard', {
          location: this.digiBoardLocation,
          board_number: this.digiBoardNumber,
          timezone: this.timeZone,
          organization_id: this.selectedOrganizationId,
        });
        await this.$store.dispatch('digiboards/createDigiBoardLicence', {
          type: this.type,
          start: this.convertToGmt(this.start),
          end: this.convertToGmt(this.end),
          digi_board_id: this.createdDigiBoard.external_id,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Digi-Board Created successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.$store.dispatch('digiboards/clearCreatedDigiBoard');
          this.loading = false;
          this.$router.push({ name: 'DigiBoards' });
        }).catch(() => {
          this.loading = false;
        });
      },
      getAllTimeZone () {
        this.$store.dispatch('users/fetchTimeZones');
      },
    },
  };
</script>
<style scoped>
.my-vcard-style {
  margin-right: 30px;
  margin-left: 30px;
  background-color: #ECEFF1;
  border-radius: 25px;
}
.my-base-vcard-style {
  background-color: #CFD8DC !important;
}
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
</style>
